__turbopack_context__.v({
  "archidektButton": "CbPPTq_archidektButton",
  "archidektIcon": "CbPPTq_archidektIcon",
  "buttonWrap": "CbPPTq_buttonWrap",
  "container": "CbPPTq_container",
  "heading": "CbPPTq_heading",
  "main": "CbPPTq_main",
  "mainCatalog": "CbPPTq_mainCatalog",
  "mainFeatured": "CbPPTq_mainFeatured",
  "mainFeaturedInner": "CbPPTq_mainFeaturedInner",
});
